import React from 'react';
import { Svg } from 'components';
import { ScrollToTopContainer } from './styled';

function ScrollToTop(): JSX.Element {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <div onClick={scrollToTop} role="button" tabIndex={0}>
      <ScrollToTopContainer>
        <Svg name="scrollTop" width="36px" height="57px" />
      </ScrollToTopContainer>
    </div>
  );
}

export default ScrollToTop;
